
import { of as observableOf, Observable, from } from 'rxjs';
import { catchError, exhaustMap, map, startWith, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { LGEDataService, IFormRequestInt, IFormRequestExt } from '../../../commons';
import {
  HomeActionTypes,
  LoadFormCCApprovedStateSuccess,
  LoadFormCCExceptDraftState,
  LoadFormCCExceptDraftStateSuccess,
  LoadFormCCPendingApprovalStateSuccess,
  LoadFormCGApprovedStateSuccess,
  LoadFormCGExceptDraftState,
  LoadFormCGExceptDraftStateSuccess,
  LoadFormCGPendingApprovalStateSuccess,
  LoadFormESApprovedStateSuccess,
  LoadFormESExceptDraftStateSuccess,
  LoadFormESPendingApprovalStateSuccess,
  LoadFormMGExceptDraftState,
  LoadFormMGExceptDraftStateSuccess,
  LoadFormPPApprovedStateSuccess,
  LoadFormPPExceptDraftStateSuccess,
  LoadFormPPPendingApprovalStateSuccess,
  LoadHomeStateFail,
  LoadUserExtStateSuccess,
  LoadUserIntStateSuccess,
} from './home.actions';
import { HomeError } from 'src/commons/interfaces/screens.interface';

@Injectable()
export class HomeEffects {


  loaduserIntState$ = createEffect(() => this.actions$
    .pipe(
      ofType(HomeActionTypes.LoadUserIntState)
      , switchMap(() =>
        from(this.lgeService.formCCByUserId())
          .pipe(map((state: IFormRequestInt) => new LoadUserIntStateSuccess(state))
            , catchError((error: Error) => {
              const err: HomeError = {
                hasError: true,
                errorMessage: JSON.stringify(error),
                form: 'UserInt'
              }
              return observableOf(new LoadHomeStateFail(err))
            }))
      )));


  loaduserExtState$ = createEffect(() => this.actions$
    .pipe(
      ofType(HomeActionTypes.LoadUserExtState),
      switchMap(() =>
        from(this.lgeService.formExtByUserId())
          .pipe(
            map(
              (state: IFormRequestExt) =>
                new LoadUserExtStateSuccess(state)
            ),
            catchError((error: Error) => {
              const err: HomeError = {
                hasError: true,
                errorMessage: JSON.stringify(error),
                form: 'UserExt'
              }
              return observableOf(new LoadHomeStateFail(err))
            }))
      )));

  // Admin: CC

  loadFormCCExceptDraft$ = createEffect(() => this.actions$
    .pipe(
      ofType(HomeActionTypes.LoadFormCCExceptDraftState),
      exhaustMap(() =>
        from(this.lgeService.FormCCByStatusIdExceptDraft())
          .pipe(
            map(
              (state: IFormRequestInt) => new LoadFormCCExceptDraftStateSuccess(state)
            )
            , catchError((error: Error) => {
              const err: HomeError = {
                hasError: true,
                errorMessage: JSON.stringify(error),
                form: 'FormCCExceptDraft'
              }
              return observableOf(new LoadHomeStateFail(err))
            }))
      )));

  // Admin: MG

  loadFormMGExceptDraft$ = createEffect(
    () => this.actions$
      .pipe(
        ofType(HomeActionTypes.LoadFormMGExceptDraftState),
        switchMap(() =>
          from(this.lgeService.FormMGByStatusIdExceptDraft())
            .pipe(
              map(
                (state: IFormRequestInt) => new LoadFormMGExceptDraftStateSuccess(state)
              )
              , catchError((error: Error) => {
                const err: HomeError = {
                  hasError: true,
                  errorMessage: JSON.stringify(error),
                  form: 'FormMGExceptDraft'
                }
                return observableOf(new LoadHomeStateFail(err))
              }))
        )));

  // Admin: CG

  loadFormCGExceptDraft$ = createEffect(
    () => this.actions$
      .pipe(ofType(HomeActionTypes.LoadFormCGExceptDraftState),
        switchMap(() =>
          from(this.lgeService.FormCGByStatusIdExceptDraft())
            .pipe(
              map(
                (state: IFormRequestExt) => new LoadFormCGExceptDraftStateSuccess(state)
              )
              , catchError((error: Error) => {
                const err: HomeError = {
                  hasError: true,
                  errorMessage: JSON.stringify(error),
                  form: 'FormCGExceptDraft'
                }
                return observableOf(new LoadHomeStateFail(err))
              }))
        )));

  // Admin: ES

  loadFormESExceptDraft$ = createEffect(
    () => this.actions$
      .pipe(ofType(HomeActionTypes.LoadFormESExceptDraftState),
        switchMap(() =>
          from(this.lgeService.FormESByStatusIdExceptDraft())
            .pipe(
              map(
                (state: IFormRequestExt) => new LoadFormESExceptDraftStateSuccess(state)
              )
              , catchError((error: Error) => {
                const err: HomeError = {
                  hasError: true,
                  errorMessage: JSON.stringify(error),
                  form: 'FormESExceptDraft'
                }
                return observableOf(new LoadHomeStateFail(err))
              }))
        )))

  // Admin: PP

  loadFormPPExceptDraft$ = createEffect(
    () => this.actions$
      .pipe(ofType(HomeActionTypes.LoadFormPPExceptDraftState), switchMap(() =>
        from(this.lgeService.FormPPByStatusIdExceptDraft())
          .pipe(
            map(
              (state: IFormRequestExt) => new LoadFormPPExceptDraftStateSuccess(state)
            )
            , catchError((error: Error) => {
              const err: HomeError = {
                hasError: true,
                errorMessage: JSON.stringify(error),
                form: 'FormPPExceptDraft'
              }
              return observableOf(new LoadHomeStateFail(err))
            }))
      )));

  // Approve: FormCC

  loadFormCCPendingApproval$ = createEffect(() => this.actions$
    .pipe(ofType(HomeActionTypes.LoadFormCCPendingApprovalState), switchMap(() => {
      let data: any = {};
      data.userId = '';
      data.approvalStatus = 'PendingApproval';
      data.status = 'PendingApproval';
      return from(this.lgeService.getPendingApprovalFormCCDetails(data))
        .pipe(
          map((state: IFormRequestInt) => new LoadFormCCPendingApprovalStateSuccess(state)),
          catchError((error: Error) => {
            const err: HomeError = {
              hasError: true,
              errorMessage: JSON.stringify(error),
              form: 'FormCCPendingApproval'
            }
            return observableOf(new LoadHomeStateFail(err))
          }))
    })));


  loadFormCCApproved$ = createEffect(() => this.actions$
    .pipe(ofType(HomeActionTypes.LoadFormCCApprovedState), switchMap(() => {
      let data: any = {};
      data.userId = '';
      data.approvalStatus = 'Approved';
      data.status = 'Done';
      return from(this.lgeService.getPendingApprovalFormCCDetails(data))
        .pipe(map((state: IFormRequestInt) => new LoadFormCCApprovedStateSuccess(state))
          , catchError((error: Error) => {
            const err: HomeError = {
              hasError: true,
              errorMessage: JSON.stringify(error),
              form: 'FormCCApproved'
            }
            return observableOf(new LoadHomeStateFail(err))
          }))
    })));


  // Approve: FormCG

  loadFormCGPendingApproval$ = createEffect(() => this.actions$
    .pipe(ofType(HomeActionTypes.LoadFormCGPendingApprovalState), switchMap(() => {
      let data: any = {};
      data.approvalStatus = 'PendingApproval';
      data.status = 'PendingApproval';
      return from(this.lgeService.GetFormCGPendingOrApproved(data))
        .pipe(map((state: IFormRequestExt) => new LoadFormCGPendingApprovalStateSuccess(state))
          , catchError((error: Error) => {
            const err: HomeError = {
              hasError: true,
              errorMessage: JSON.stringify(error),
              form: 'FormCGPendingApproval'
            }
            return observableOf(new LoadHomeStateFail(err))
          }))
    })));


  loadFormCGApproved$ = createEffect(() => this.actions$
    .pipe(ofType(HomeActionTypes.LoadFormCGApprovedState), switchMap(() => {
      let data: any = {};
      data.approvalStatus = 'Approved';
      data.status = 'Done';
      return from(this.lgeService.GetFormCGPendingOrApproved(data))
        .pipe(map((state: IFormRequestExt) => new LoadFormCGApprovedStateSuccess(state))
          , catchError((error: Error) => {
            const err: HomeError = {
              hasError: true,
              errorMessage: JSON.stringify(error),
              form: 'FormCGApproved'
            }
            return observableOf(new LoadHomeStateFail(err))
          }))
    })));


  // Approve: FormES

  loadFormESPendingApproval$ = createEffect(() => this.actions$
    .pipe(ofType(HomeActionTypes.LoadFormESPendingApprovalState), switchMap(() => {
      let data: any = {};
      data.approvalStatus = 'PendingApproval';
      data.status = 'PendingApproval';
      return from(this.lgeService.GetFormESPendingOrApproved(data))
        .pipe(map((state: IFormRequestExt) => new LoadFormESPendingApprovalStateSuccess(state))
          , catchError((error: Error) => {
            const err: HomeError = {
              hasError: true,
              errorMessage: JSON.stringify(error),
              form: 'FormESPendingApproval'
            }
            return observableOf(new LoadHomeStateFail(err))
          }))
    })));


  loadFormESApproved$ = createEffect(() => this.actions$
    .pipe(ofType(HomeActionTypes.LoadFormESApprovedState), switchMap(() => {
      let data: any = {};
      data.approvalStatus = 'Approved';
      data.status = 'Done';
      return from(this.lgeService.GetFormESPendingOrApproved(data))
        .pipe(map((state: IFormRequestExt) => new LoadFormESApprovedStateSuccess(state))
          , catchError((error: Error) => {
            const err: HomeError = {
              hasError: true,
              errorMessage: JSON.stringify(error),
              form: 'FormESApproved'
            }
            return observableOf(new LoadHomeStateFail(err))
          }))
    })));


  // Approve: FormPP

  loadFormPPPendingApproval$ = createEffect(() => this.actions$
    .pipe(ofType(HomeActionTypes.LoadFormPPPendingApprovalState), switchMap(() => {
      let data: any = {};
      data.approvalStatus = 'PendingApproval';
      data.status = 'PendingApproval';
      return from(this.lgeService.GetFormPPPendingOrApproved(data))
        .pipe(map((state: IFormRequestExt) => new LoadFormPPPendingApprovalStateSuccess(state))
          , catchError((error: Error) => {
            const err: HomeError = {
              hasError: true,
              errorMessage: JSON.stringify(error),
              form: 'FormPPPendingApproval'
            }
            return observableOf(new LoadHomeStateFail(err))
          }))
    })));


  loadFormPPApproved$ = createEffect(() => this.actions$
    .pipe(ofType(HomeActionTypes.LoadFormPPApprovedState), switchMap(() => {
      let data: any = {};
      data.approvalStatus = 'Approved';
      data.status = 'Done';
      return from(this.lgeService.GetFormPPPendingOrApproved(data))
        .pipe(map((state: IFormRequestExt) => new LoadFormPPApprovedStateSuccess(state))
          , catchError((error: Error) => {
            const err: HomeError = {
              hasError: true,
              errorMessage: JSON.stringify(error),
              form: 'FormPPApproved'
            }
            return observableOf(new LoadHomeStateFail(err))
          }))
    })));

  constructor(
    private actions$: Actions,
    private lgeService: LGEDataService
  ) { }
}


